import type { MouseEvent } from 'react';
import { UnstyledButton } from '@mantine/core';
import { IconBuilding } from '@tabler/icons-react';
import { useCustomerDrawerStore } from '../stores/customerDrawerStore';

interface Props {
  name: string;
  cwCompanyId?: number;
  weclappCustomerId?: string;
}

export function CustomerNameLink({ name, cwCompanyId, weclappCustomerId }: Props) {
  const openDrawer = useCustomerDrawerStore((s) => s.openDrawer);
  const hasId = cwCompanyId != null || weclappCustomerId != null;

  if (!hasId) return <span>{name}</span>;

  const provider = cwCompanyId != null ? 'connectwise' : 'weclapp';
  const customerId = cwCompanyId != null ? String(cwCompanyId) : weclappCustomerId!;

  return (
    <UnstyledButton
      onClick={(e: MouseEvent) => {
        e.stopPropagation();
        openDrawer(customerId, name, provider);
      }}
      title="Kundenakte öffnen"
      style={{
        // Deutlich als Link erkennbar: Anchor-Farbe + Gebäude-Icon + durchgehende
        // Unterstreichung — die gepunktete Variante wurde nicht als klickbar gelesen.
        color: 'var(--mantine-color-anchor)',
        textDecoration: 'underline',
        textUnderlineOffset: 3,
        cursor: 'pointer',
        font: 'inherit',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <IconBuilding size={13} style={{ flexShrink: 0 }} />
      {name}
    </UnstyledButton>
  );
}
